import {Component, Inject} from 'ng-metadata/core';
import {NewspapersService} from '../newspapers.service';
import {beacon, PrimolyticsService} from "../../analytics/primolytics.service";


@Component({
    selector: 'prm-newspapers-facet',
    templateUrl: 'components/newspapers/newspapersFacet/newspapers-facet.html',
})

export class PrmNewspapersFacet{

    constructor(private newspapersService: NewspapersService,
                private primolyticsService: PrimolyticsService,
                @Inject('availabilityLineIcons') private availabilityLineIcons) {
    }

    @beacon({ 'p': 'general', 'op': 'goToNewspapersfromRegularSearch' })
    private goToNewspapers(){
        this.newspapersService.addCameFromGoToNewspapersfromRegularSearch('facetRT');
        this.newspapersService.goToNewspapersFromSearch();
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/newspapers/newspapersFacet/newspapersFacet.directive.ts